import React from "react";
import { VALIDATION } from "../../../constants";
import { WebinarHost, WebinarTopic } from "../../../types/models";
import { SessionFormState } from "../../../utils/sessionFormState";
import HostPicker from "../../HostPicker/HostPicker";
import TopicPicker from "../../TopicPicker/TopicPicker";

type Props = {
  form: SessionFormState;
  hosts: WebinarHost[];
  topics: WebinarTopic[];
  setField: <K extends keyof SessionFormState>(
    key: K,
    value: SessionFormState[K]
  ) => void;
  onHostsChange: (hosts: WebinarHost[]) => void;
  onTopicsChange: (topics: WebinarTopic[]) => void;
};

const BasicsStep: React.FC<Props> = ({
  form,
  hosts,
  topics,
  setField,
  onHostsChange,
  onTopicsChange,
}) => {
  const titleLen = form.title.trim().length;
  const titleFg =
    titleLen === 0
      ? "#918A82"
      : titleLen < VALIDATION.titleMin || titleLen > VALIDATION.titleMax
      ? "#B4483A"
      : "#238A5E";

  return (
    <div className="wf-step">
      <div>
        <div className="wf-field-head">
          <label>
            Title <span className="req">*</span>
          </label>
          <span className="count" style={{ color: titleFg }}>
            {titleLen} / {VALIDATION.titleMax}
          </span>
        </div>
        <input
          type="text"
          value={form.title}
          maxLength={VALIDATION.titleMax}
          onChange={(e) => setField("title", e.target.value)}
          placeholder="e.g. PCOS and insulin resistance: breaking the loop"
          className="wf-input"
        />
      </div>

      <div>
        <div className="wf-field-head">
          <label>
            One-line description <span className="req">*</span>
          </label>
          <span className="count">
            {form.oneLiner.trim().length} / {VALIDATION.oneLinerMax}
          </span>
        </div>
        <input
          type="text"
          value={form.oneLiner}
          maxLength={VALIDATION.oneLinerMax}
          onChange={(e) => setField("oneLiner", e.target.value)}
          placeholder="The line that sits under the title on the session card"
          className="wf-input"
        />
      </div>

      <div>
        <label className="wf-field__label" style={{ marginBottom: 9 }}>
          Topic / theme <span className="req">*</span>
        </label>
        <TopicPicker
          topics={topics}
          value={form.topicId}
          onChange={(id) => setField("topicId", id)}
          onTopicsChange={onTopicsChange}
        />
      </div>

      <div>
        <label className="wf-field__label" style={{ marginBottom: 9 }}>
          Host <span className="req">*</span>
        </label>
        <HostPicker
          hosts={hosts}
          value={form.hostId}
          onChange={(id) => setField("hostId", id)}
          onHostsChange={onHostsChange}
        />
      </div>
    </div>
  );
};

export default BasicsStep;
